import React from 'react';
import formStyles from '../../../form/Form.module.css';
import Input from '../../../form/Input';
import InputFloat from '../../../form/InputFloat';
import InputNumber from '../../../form/InputNumber';
import Select from '../../../form/Select';
import { formatarNumero } from '../../../../utils/masks';

const ImovelSection = ({ bem, actions, state }) => {
    return (
        <>
            <div className={formStyles.preview_bandeira}>
                <h4>Dados do Imóvel</h4>
            </div>

            {/* Registros e Contadores */}
            <div className={formStyles.row}>
                <Input
                    text="Inscrição Municipal"
                    name="produtoBens.inscricaoMunicipal"
                    handleOnChange={actions.draft.change}
                    value={bem.inscricaoMunicipal}
                />
                <Input
                    text="Matrícula"
                    name="produtoBens.matricula"
                    handleOnChange={actions.draft.change}
                    value={bem.matricula}
                />
                <Input
                    text="Contador Água"
                    name="produtoBens.contadorAgua"
                    handleOnChange={actions.draft.change}
                    value={bem.contadorAgua}
                />
                <Input
                    text="Contador Energia"
                    name="produtoBens.contadorEnergia"
                    handleOnChange={actions.draft.change}
                    value={bem.contadorEnergia}
                />
            </div>

            {/* Medidas Terreno */}
            <div className={formStyles.row}>
                <InputNumber
                    text="Frente"
                    name="produtoBens.frente"
                    handleOnChange={actions.draft.change}
                    value={bem.frente ? formatarNumero(bem.frente) : ''}
                />
                <InputNumber
                    text="Fundo"
                    name="produtoBens.fundo"
                    handleOnChange={actions.draft.change}
                    value={bem.fundo ? formatarNumero(bem.fundo) : ''}
                />
                <InputNumber
                    text="Lado Direito"
                    name="produtoBens.ladoDireito"
                    handleOnChange={actions.draft.change}
                    value={bem.ladoDireito ? formatarNumero(bem.ladoDireito) : ''}
                />
                <InputNumber
                    text="Lado Esquerdo"
                    name="produtoBens.ladoEsquerdo"
                    handleOnChange={actions.draft.change}
                    value={bem.ladoEsquerdo ? formatarNumero(bem.ladoEsquerdo) : ''}
                />
                <InputNumber
                    text="Área Total"
                    name="produtoBens.areaTotal"
                    handleOnChange={actions.draft.change}
                    value={bem.areaTotal ? formatarNumero(bem.areaTotal) : ''}
                />
                <InputNumber
                    text="Área Construída"
                    name="produtoBens.areaConstruida"
                    handleOnChange={actions.draft.change}
                    value={bem.areaConstruida ? formatarNumero(bem.areaConstruida) : ''}
                />
                <InputFloat
                    text="Latitude"
                    type="text"
                    name="produtoBens.latitude"
                    placeholder="Latitude"
                    title="Latitude"
                    handleOnChange={actions.draft.change}
                    value={bem.latitude || ''}
                    textAlign="right"
                />

                <InputFloat
                    text="Longitude"
                    type="text"
                    name="produtoBens.longitude"
                    placeholder="Longitude"
                    title="Longitude"
                    handleOnChange={actions.draft.change}
                    value={bem.longitude || ''}
                    textAlign="right"
                />
            </div>

            {/* Endereço */}
            <div className={formStyles.row}>
                <Input
                    text="CEP"
                    name="produtoBens.cep"
                    handleOnBlur={actions.draft.handleCepBlur}
                    handleOnChange={actions.draft.change}
                    value={bem.cep}
                />
                <Select
                    text="UF"
                    name="produtoBens.ufId"
                    options={state.optionsUF}
                    handleOnChange={actions.draft.change}
                    value={bem.ufId}
                    notOptNull={false}
                />
                <Select
                    text="Município"
                    name="produtoBens.municipioId"
                    options={state.optionsMunicipios}
                    handleOnChange={actions.draft.change}
                    value={bem.municipioId}
                    notOptNull={false}
                />
                <Input
                    text="Bairro"
                    name="produtoBens.bairro"
                    handleOnChange={actions.draft.change}
                    value={bem.bairro}
                    inputWidth="300px"
                />
            </div>

            <div className={formStyles.row}>
                <Input
                    text="Logradouro"
                    name="produtoBens.logradouro"
                    handleOnChange={actions.draft.change}
                    value={bem.logradouro}
                    inputWidth="350px"
                />
                <Input text="Número" name="produtoBens.numero" handleOnChange={actions.draft.change} value={bem.numero} />
                <Input
                    text="Complemento"
                    name="produtoBens.complemento"
                    handleOnChange={actions.draft.change}
                    value={bem.complemento}
                    inputWidth="350px"
                />
            </div>
        </>
    );
};

export default ImovelSection;
